export { SEARCH, OFFERING_IDS, PLAN_TYPE, PRICE_RANGE, MIN_OVERALL_RATING, HAS_FREE_SUPPORT, SORT_FIELDS, LIMIT, OFFSET, MIN_REVIEW_COUNT, PROVIDERS, TIERS, PORTAL_COMPATIBLE, TAGS } from '../../common/constants/AssetBaseQueryField';
export const CATEGORIES = 'categories';
export const TEMPLATE_TYPE = 'templateType';